module.exports = __webpack_public_path__ + "static/media/leafent.aee09ae4.png";